import React, { useContext, useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { ContactContext } from 'contexts/contactContext'
import { LegalFormalitiesContext } from 'contexts/legalFormalitiesContext'
import CurrentLegalFormalityContextProvider from 'contexts/LegalFormalityContext'
import CentredLoader from 'components/CentredLoader'
import LegalFormality from './LegalFormality'

import { LEGAL_FORMALITY_QUERY } from 'graphql/LegalFormalities'
import CompanyStaffsContextProvider from 'contexts/CompanyStaffsContext'

const LegalFormalities = () => {
  const urlParams = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { contact } = useContext(ContactContext)
  const { legalFormalities } = useContext(LegalFormalitiesContext)

  const [currentLegalFormalityId, setCurrentLegalFormalityId] = useState<
    string | number | undefined
  >(urlParams.tabItemId)

  // navigate to first legal formality if url finish with '.../legal_formalities'
  useEffect(() => {
    urlParams.tabKey === 'legal_formalities' &&
      !urlParams.tabItemId &&
      handleSelectFormality(`${legalFormalities[0] && legalFormalities[0].id}`)
  }, [location])

  const handleSelectFormality = (formalityId: string) => {
    setCurrentLegalFormalityId(formalityId)
    navigate(`/contacts/${contact.id}/legal_formalities/${formalityId}`)
  }

  const { data, loading, error, refetch } = useQuery(LEGAL_FORMALITY_QUERY, {
    variables: {
      id: currentLegalFormalityId,
    },
  })

  if (loading) {
    return <CentredLoader />
  }

  if (error || !data.legalFormality) {
    return <p>{`Impossible to load Formality`}</p>
  }

  const currentLegalFormality = data &&
    data.legalFormality && {
      ...data.legalFormality,
      metadatum: JSON.parse(data.legalFormality.metadatum),
    }

  return (
    currentLegalFormality && (
      <CurrentLegalFormalityContextProvider
        currentLegalFormality={currentLegalFormality}
        legalFormalityLoading={loading}
        legalFormalityRefetch={refetch}
      >
        <CompanyStaffsContextProvider contactId={contact.id}>
          <LegalFormality />
        </CompanyStaffsContextProvider>
      </CurrentLegalFormalityContextProvider>
    )
  )
}

export default LegalFormalities
